module.exports = __webpack_public_path__ + "img/pausa.a6d3824e.svg";